import { Component, forwardRef, Renderer2, ViewChild, Input, Output, OnChanges, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CountryService } from '../../../service/country/country.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectCountryComponent),
  multi: true,
};

@Component({
  selector: 'app-select-country',
  templateUrl: './select-country.component.html',
  styleUrls: ['./select-country.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class SelectCountryComponent implements ControlValueAccessor,OnChanges {
    @Input() countryId: number;
    @ViewChild('input') textarea;
    @Input() disabled: boolean;
    @Output() onMyChange = new EventEmitter();

    public countriesOptions: any[];
    public outputObject: any;

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    constructor(
        private renderer: Renderer2,
        public countryService: CountryService
    ) {
        this.page = 1;
        this.per_page = 30;
        this.query = undefined;
        this.filters = [];
        // this.filters.push({key: 'activated-lk', value: '1'});
        //this.getCountries(this.query, this.filters);
    }
    ngOnInit(){
        // this.getCountries(this.query, this.filters);
    }
    ngOnChanges(){
        this.getCountries(this.query, this.filters);//this.ngOnInit();
    }
    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    // setDisabledState(isDisabled: boolean ) {
    //     const div = this.textarea.nativeElement;
    //     const action = isDisabled ? 'addClass' : 'removeClass';
    //     this.renderer[action](div, 'disabled');
    // }

    setDisabledState(isDisabled: boolean ) {
        this.disabled = isDisabled;
    }

    public change($event) {
        this.outputObject = this.countriesOptions.find((item) => item.id == $event.target.value);
        // this.onMyChange.emit(this.outputObject);
        // this.onChange(this.outputObject);
        // this.onTouched(this.outputObject);
        this.emitOutput(this.outputObject);
    }

    getCountries(query?: string, filters?: any[]) {
        this.countryService.getCountry(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                var countries = response.json().data;
                countries = this.sortData(countries, 'asc');

                this.countriesOptions = [];
                this.countriesOptions.push({id: undefined, name: 'choose', code_sorttime: undefined});
                countries.forEach(element => {
                    if (this.countryId == element.id) {
                        this.countriesOptions.push({id: element.id, name: element.name, selected: true, code_sorttime: element.code_sorttime});
                        this.emitOutput({id: element.id, name: element.name, selected: true, code_sorttime: element.code_sorttime});
                    } 
                    else {
                        this.countriesOptions.push({id: element.id, name: element.name, selected: false, code_sorttime: element.code_sorttime});
                    }
                });
                
            },
            error => {
                this.countriesOptions = [];
                this.countriesOptions.push({id: '', name: 'Error'});
            }
        );
    }
    public emitOutput(value: any)
    {   
        this.onMyChange.emit(value);
        this.onChange(value);//this.onChange = "";//
        this.onTouched(value);//this.onTouched = ""; //
    }
    public sortData(data, type) {
        let ordered = [];
        let dataArr = [].slice.call(data);
        let dataSorted = dataArr.sort((a, b) => {
            if (type === "asc") {
                if (a.name < b.name) return -1
                else return 1
            } else {
                if (a.name > b.name) return -1
                else return 1
            }
        });
        dataSorted.forEach(e => {
            var words = e.name.split(" ");
            for(var i = 0; i < words.length; i++){
                words[i] = words[i].toLowerCase();
                if(words[i] != "y" && words[i] != "de")
                    words[i] = this.capitalize(words[i]);
            }
            e.name = words.join(" ");
            ordered.push(e);
        });
        return ordered;
    }

    public capitalize(word) {
        return word[0].toUpperCase() + word.slice(1);
    }
    
    public lowerCase(word){
        const palabras = word.toLowerCase();
    }
}


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/countries/select-country/select-country.component.ts